<div class="layout-col full">
  <span style="width: 80vw"></span>

  <app-control-center-detail class="flex" [controlCenter]="controlCenter" (close)="onClose($event)">
  </app-control-center-detail>
</div>
